/**
 * Search Bar – Slide Down
 */

(function () {

  const wrapper = document.getElementById('SearchBarWrapper');
  if (!wrapper) { console.warn('[SearchBar] #SearchBarWrapper not found'); return; }

  /* ============================================
     1. MOUNT ON BODY + POSITION BELOW HEADER
  ============================================ */

  function findHeader() {
    const selectors = [
      '.shopify-section-group-header-group', '.site-header',
      'header.site-header', 'header.header',
      '.header__wrapper', '.header-wrapper',
      '[data-section-type="header"]', 'header',
    ];
    let best = null, bestBottom = 0;
    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (!el) continue;
      const rect = el.getBoundingClientRect();
      if (rect.height < 10 || rect.top > window.innerHeight * 0.3) continue;
      if (rect.bottom > bestBottom) { bestBottom = rect.bottom; best = el; }
    }
    return best;
  }

  function positionBelowHeader() {
    const header = findHeader();
    if (!header) { wrapper.style.setProperty('--search-bar-top', '60px'); return; }
    const rect = header.getBoundingClientRect();
    wrapper.style.setProperty('--search-bar-top', `${Math.max(0, rect.bottom)}px`);
  }

  if (wrapper.parentNode !== document.body) document.body.appendChild(wrapper);
  positionBelowHeader();
  window.addEventListener('resize', positionBelowHeader, { passive: true });
  window.addEventListener('scroll', () => { if (wrapper.classList.contains('is-open')) positionBelowHeader(); }, { passive: true });
  window.addEventListener('load', positionBelowHeader);
  if (window.visualViewport) window.visualViewport.addEventListener('resize', positionBelowHeader, { passive: true });

  /* ============================================
     2. ELEMENT REFS
  ============================================ */

  const closeBtn       = document.getElementById('SearchBarClose');
  const form           = wrapper.querySelector('form.search-bar__form');
  const input          = form ? form.querySelector('input[type="search"]') : null;
  const resetBtn       = form ? form.querySelector('button[type="reset"]') : null;
  const sectionId      = form ? form.getAttribute('data-section-id') : null;
  const resultsSection = form ? (form.getAttribute('data-results-section') || 'search-bar-results') : 'search-bar-results';
  const resultsContainer = sectionId
    ? document.getElementById(`PredictiveSearchResults-${sectionId}`)
    : null;
  const noResultsCollectionTemplate = sectionId
    ? document.getElementById(`SearchBarNoResultsCollection-${sectionId}`)
    : null;

  /* ============================================
     3. BIND TRIGGER BUTTONS
  ============================================ */

  function bindTriggers() {
    const triggers = Array.from(document.querySelectorAll(
      '[aria-controls="SearchDrawer"], [data-open-search], .header__search-toggle, .js-search-open'
    ));
    triggers.forEach((trigger) => {
      if (trigger.dataset.searchBarBound) return;
      const fresh = trigger.cloneNode(true);
      fresh.dataset.searchBarBound = '1';
      trigger.parentNode.replaceChild(fresh, trigger);
      fresh.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); openSearchBar(); });
    });
  }

  bindTriggers();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindTriggers);
  else setTimeout(bindTriggers, 500);

  /* ============================================
     4. TYPEWRITER ANIMATION
  ============================================ */

  function initTypewriter() {
    if (!input) return;
    let words = [];
    try { words = JSON.parse(wrapper.getAttribute('data-typewriter-words') || '[]'); } catch (e) { return; }
    if (!Array.isArray(words) || words.length === 0) return;

    const prefix       = (wrapper.getAttribute('data-typewriter-prefix') || '').trim();
    const speedSetting = Math.min(10, Math.max(1, parseInt(wrapper.getAttribute('data-typewriter-speed') || '5', 10)));
    const pauseSetting = Math.min(6,  Math.max(1, parseInt(wrapper.getAttribute('data-typewriter-pause') || '2', 10)));
    const typeDelay    = Math.round(140 - (speedSetting - 1) * (120 / 9));
    const eraseDelay   = Math.round(typeDelay * 0.55);
    const pauseMs      = pauseSetting * 1000;
    let wordIndex = 0, charIndex = 0, isErasing = false, animTimer = null, userTyping = false;

    function setPlaceholder(word, chars) {
      const partial = word.slice(0, chars);
      input.placeholder = prefix ? `${prefix} "${partial}"` : partial;
    }
    function tick() {
      if (userTyping) { animTimer = setTimeout(tick, 300); return; }
      const word = words[wordIndex];
      if (!isErasing) {
        charIndex++;
        setPlaceholder(word, charIndex);
        if (charIndex >= word.length) { isErasing = true; animTimer = setTimeout(tick, pauseMs); }
        else { animTimer = setTimeout(tick, typeDelay); }
      } else {
        charIndex--;
        setPlaceholder(word, charIndex);
        if (charIndex <= 0) { isErasing = false; wordIndex = (wordIndex + 1) % words.length; charIndex = 0; animTimer = setTimeout(tick, 500); }
        else { animTimer = setTimeout(tick, eraseDelay); }
      }
    }
    input.addEventListener('input', () => { userTyping = input.value.length > 0; });
    input.addEventListener('blur',  () => { if (!input.value) userTyping = false; });
    animTimer = setTimeout(tick, 800);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTypewriter);
  else initTypewriter();

  /* ============================================
     5. OPEN / CLOSE
  ============================================ */

  function openSearchBar() {
    positionBelowHeader();
    ensureProductPrefetch();
    wrapper.classList.add('is-open');
    wrapper.setAttribute('aria-hidden', 'false');
    if (closeBtn) closeBtn.setAttribute('aria-expanded', 'true');
    setTimeout(() => { if (input) input.focus(); }, 150);
  }

  function closeSearchBar() {
    wrapper.classList.remove('is-open');
    wrapper.setAttribute('aria-hidden', 'true');
    if (closeBtn) closeBtn.setAttribute('aria-expanded', 'false');
    if (input) { input.value = ''; input.blur(); }
    if (form)  { form.removeAttribute('results'); form.removeAttribute('loading'); }
    clearResults();
  }

  window.openSearchBar  = openSearchBar;
  window.closeSearchBar = closeSearchBar;

  if (closeBtn) closeBtn.addEventListener('click', closeSearchBar);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && wrapper.classList.contains('is-open')) closeSearchBar(); });
  document.addEventListener('click', (e) => {
    if (!wrapper.classList.contains('is-open')) return;
    if (wrapper.contains(e.target)) return;
    if (e.target.closest('[aria-controls="SearchDrawer"], [data-open-search], .header__search-toggle, .js-search-open')) return;
    closeSearchBar();
  });

  /* ============================================
     6. SLIDER ARROW BUTTONS
  ============================================ */

  wrapper.addEventListener('click', (e) => {
    const arrow = e.target.closest('.srec__arrow');
    if (!arrow) return;
    const sliderId = arrow.getAttribute('data-slider');
    const slider   = sliderId
      ? document.getElementById(sliderId)
      : arrow.closest('.srec__slider-wrap, .search__products-slider-wrap')
             ?.querySelector('.srec__slider, .search__products-slider');
    if (!slider) return;
    slider.scrollBy({ left: slider.clientWidth * 0.75, behavior: 'smooth' });
  });

  /* ============================================
     7. SEARCH LOGIC
  ============================================ */

  if (!form || !input) { console.warn('[SearchBar] form or input missing, search disabled'); return; }

  /* ── Strategy A: Section Rendering API ─────────────────────────────── */

  let activeCtrl   = null;
  let currentQuery = '';
  const responseCache = new Map();

  async function fetchViaSectionAPI(query) {
    if (!sectionId) return false;

    const cacheKey = query.toLowerCase();
    if (responseCache.has(cacheKey)) {
      const liveContainer = document.getElementById(`PredictiveSearchResults-${sectionId}`);
      if (!liveContainer) return false;
      liveContainer.innerHTML = responseCache.get(cacheKey);
      form.removeAttribute('loading');
      form.setAttribute('results', '');
      return true;
    }

    if (activeCtrl) activeCtrl.abort();
    activeCtrl = new AbortController();

    form.setAttribute('loading', '');
    form.removeAttribute('results');

    try {
      const params = new URLSearchParams({
        section_id: resultsSection,
        q: query,
        type: 'product',
        'options[prefix]': 'last',
      });

      const res = await fetch(`/search?${params.toString()}`, { signal: activeCtrl.signal });
      if (!res.ok) return false;

      const html = await res.text();
      if (input.value.trim() !== query || currentQuery !== query) return true;

      const parsed   = new DOMParser().parseFromString(html, 'text/html');
      const newInner = parsed.getElementById('SearchBarProductResults');
      if (!newInner) return false;

      const liveContainer = document.getElementById(`PredictiveSearchResults-${sectionId}`);
      if (!liveContainer) return false;

      const finalHtml = resolveResultsHtml(newInner, query);

      liveContainer.innerHTML = finalHtml;
      responseCache.set(cacheKey, finalHtml);
      form.removeAttribute('loading');
      form.setAttribute('results', '');
      return true;

    } catch (err) {
      if (err.name === 'AbortError') return true;
      console.error('[SearchBar] Section API fetch error:', err);
      return false;
    }
  }

  /* ── Strategy B: /products.json prefetch (true last resort only) ─────── */

  const HIDDEN_TAGS   = ['Clearance Sale', 'BYOB', 'search-hide', 'internal-product'];
  const MAX_RESULTS   = 8;
  const MAX_PAGES     = 5;
  let allProducts     = [];
  let fetchComplete   = false;
  let prefetchStarted = false;

  async function prefetchProducts() {
    const fetched = [];
    for (let page = 1; page <= MAX_PAGES; page++) {
      try {
        const res  = await fetch(`/products.json?limit=250&page=${page}`);
        const data = await res.json();
        const products = data.products || [];
        if (products.length === 0) break;
        fetched.push(...products);
        allProducts = fetched.filter(p => {
          const tags = typeof p.tags === 'string' ? p.tags.split(',').map(t => t.trim()) : (p.tags || []);
          return !HIDDEN_TAGS.some(h => tags.includes(h));
        });
        if (products.length < 250) break;
      } catch (e) { break; }
    }
    fetchComplete = true;
  }

  function ensureProductPrefetch() {
    if (prefetchStarted) return;
    prefetchStarted = true;
    prefetchProducts();
  }

  function searchableText(p) {
    const parts = [p.title || '', p.product_type || '', p.vendor || ''];
    if (Array.isArray(p.variants)) p.variants.forEach(v => { if (v.title && v.title !== 'Default Title') parts.push(v.title); });
    const tags = typeof p.tags === 'string' ? p.tags.split(',').map(t => t.trim()) : (p.tags || []);
    parts.push(...tags);
    return parts.join(' ').toLowerCase();
  }

  function filterProducts(query) {
    const terms = query.toLowerCase().trim().split(/\s+/).filter(Boolean);
    return allProducts.filter(p => terms.every(term => searchableText(p).includes(term))).slice(0, MAX_RESULTS);
  }

  function getImageUrl(p, size) {
    const img = (p.images && p.images[0]) || (p.featured_image ? { src: p.featured_image } : null);
    if (!img) return null;
    return img.src.replace(/(\.[a-z]+)(\?.*)?$/i, `_${size}x$1$2`);
  }

  function parsePrice(value) {
    const parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function formatPrice(value) {
    const amount = parsePrice(value);
    if (amount == null) return '';
    const symbol = (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active === 'USD') ? '$' : '₹';
    const hasDecimals = Math.abs(amount % 1) > 0.001;
    return `${symbol}${amount.toLocaleString('en-IN', {
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: hasDecimals ? 2 : 0
    })}`;
  }

  function escHtml(str) {
    return String(str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function getEmptyStateHtml(query) {
    return `
      <div class="search__empty flex justify-center items-start text-center w-full h-full" style="padding:2rem 1rem;">
        <div class="drawer__empty flex flex-col gap-5">
          <p class="drawer__empty-text h2 heading leading-none tracking-tight">No results for "${escHtml(query)}".</p>
          <p class="drawer__empty-message text-sm leading-tight">Try a different word or browse our categories.</p>
        </div>
      </div>`;
  }

  function getNoResultsHtml(query) {
    if (noResultsCollectionTemplate && noResultsCollectionTemplate.innerHTML.trim()) {
      return noResultsCollectionTemplate.innerHTML.split('__QUERY__').join(escHtml(query));
    }

    return getEmptyStateHtml(query);
  }

  function resolveResultsHtml(resultRoot, query) {
    if (!resultRoot) return '';

    const hasProductCards = resultRoot.querySelector('.search__products-section .pcard-modern, .search__products-section .srec__slide, .horizontal-products .pcard-modern');
    const hasEmptyState = resultRoot.querySelector('.search__empty');

    if (!hasProductCards && hasEmptyState) {
      return getNoResultsHtml(query);
    }

    return resultRoot.innerHTML;
  }

  /* FIX: reviews row removed entirely — JS has no access to Shopify metafields.
     Strategy A (Liquid) renders real review stars. Fallback shows nothing there. */
  function renderFallbackResults(products, query) {
    const target = resultsContainer || document.getElementById(`PredictiveSearchResults-${sectionId}`);
    if (!target) return;

    if (products.length === 0) {
      target.innerHTML = getNoResultsHtml(query);
      form.removeAttribute('loading');
      form.setAttribute('results', '');
      return;
    }

    const viewAllUrl = `/search?q=${encodeURIComponent(query)}&type=product`;
    const cards = products.map(p => {
      const primaryImage = getImageUrl(p, 533);
      const hoverImage   = p.images && p.images[1]
        ? p.images[1].src.replace(/(\.[a-z]+)(\?.*)?$/i, `_533x$1$2`)
        : null;
      const variant      = p.variants && p.variants[0] ? p.variants[0] : null;
      const priceValue   = variant ? parsePrice(variant.price) : null;
      const compareValue = variant ? parsePrice(variant.compare_at_price) : null;
      const hasDiscount  = compareValue != null && priceValue != null && compareValue > priceValue;
      const benefits     = p.body_html
        ? escHtml(String(p.body_html).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()).slice(0, 70)
        : '&nbsp;';
      const savePercent  = hasDiscount ? Math.round(((compareValue - priceValue) * 100) / compareValue) : 0;

      return `
        <div class="srec__slide">
          <div class="pcard-modern pcard-modern--plus-style pcard-modern--plus-button-style" data-product-id="${escHtml(p.id)}">
            <div class="pcard-modern__link">
              <a href="/products/${escHtml(p.handle)}" class="pcard-modern__media-link" aria-label="${escHtml(p.title)}">
                <div class="pcard-modern__media pcard-modern__media--portrait">
                  ${primaryImage ? `<img src="${escHtml(primaryImage)}" alt="${escHtml(p.title)}" class="pcard-modern__image pcard-modern__image--primary" loading="lazy">` : `<div class="pcard-modern__image pcard-modern__image--placeholder"></div>`}
                  ${hoverImage   ? `<img src="${escHtml(hoverImage)}"   alt="${escHtml(p.title)}" class="pcard-modern__image pcard-modern__image--hover"   loading="lazy">` : ''}
                </div>
              </a>
              <div class="pcard-modern__info">
                <h3 class="pcard-modern__title">
                  <a href="/products/${escHtml(p.handle)}" class="pcard-modern__title-link">${escHtml(p.title)}</a>
                </h3>
                <p class="pcard-modern__benefits">${benefits || '&nbsp;'}</p>
                <div class="pcard-modern__price-wrapper" style="margin-bottom:0;">
                  ${hasDiscount ? `
                    <div class="pcard-modern__price-group">
                      <div class="pcard-modern__price-left">
                        <div class="pcard-modern__compare-wrapper">
                          <span class="pcard-modern__price-label">MRP</span>
                          <span class="pcard-modern__compare-price">${escHtml(formatPrice(compareValue))}</span>
                        </div>
                        <div class="pcard-modern__price-main">${escHtml(formatPrice(priceValue))}</div>
                      </div>
                      <div class="pcard-modern__price-right">
                        <span class="pcard-modern__save-badge">SAVE ${escHtml(savePercent)}%</span>
                      </div>
                    </div>
                  ` : `
                    <div class="pcard-modern__price-main">${escHtml(formatPrice(priceValue))}</div>
                  `}
                </div>
              </div>
            </div>
          </div>
        </div>`;
    }).join('');

    target.innerHTML = `
      <div class="search__products-section w-full">
        <div class="search__products-header">
          <p class="search__heading block text-xs uppercase leading-tight tracking-widest">Products</p>
        </div>
        <div class="srec__slider-wrap search__products-slider-wrap">
          <div class="srec__slider search__products-slider">${cards}</div>
        </div>
      </div>
      <div class="drawer__sticky z-1 sticky left-0 bottom-0 w-full" style="padding:0.75rem 1rem;">
        <a href="${escHtml(viewAllUrl)}" class="arata-btn icon-with-text w-full" style="display:flex;align-items:center;justify-content:center;gap:0.5rem;text-decoration:none;">
          View all results for "${escHtml(query)}"
        </a>
      </div>`;

    form.removeAttribute('loading');
    form.setAttribute('results', '');
  }

  /* ── Clear results ───────────────────────────────────────────────────── */
  function clearResults() {
    form.removeAttribute('results');
    form.removeAttribute('loading');
    const target = document.getElementById(`PredictiveSearchResults-${sectionId}`);
    if (target) target.innerHTML = '';
    currentQuery = '';
  }

  /* ── Debounce ────────────────────────────────────────────────────────── */
  function debounce(fn, ms) { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; }

  /* ── Input listener ──────────────────────────────────────────────────── */
  /* FIX: Removed q.length < 3 block that was bypassing Strategy A (Liquid render)
     and forcing all short queries into the JS fallback which has no review data.
     Now every query goes through Strategy A first so Liquid renders real star ratings. */
  input.addEventListener('input', debounce(async () => {
    const q = input.value.trim();
    if (!q) { clearResults(); return; }
    if (q === currentQuery) return;
    currentQuery = q;

    const ok = await fetchViaSectionAPI(q);

    if (!ok) {
      ensureProductPrefetch();
      if (!fetchComplete && allProducts.length === 0) {
        form.setAttribute('loading', '');
        setTimeout(() => {
          const q2 = input.value.trim();
          if (q2 && allProducts.length > 0) renderFallbackResults(filterProducts(q2), q2);
        }, 250);
        return;
      }
      renderFallbackResults(filterProducts(q), q);
    }
  }, 100));

  /* ── Reset button ────────────────────────────────────────────────────── */
  if (resetBtn) {
    resetBtn.addEventListener('click', (e) => { e.preventDefault(); input.value = ''; input.focus(); clearResults(); });
  }

})();